<template>
  <div class="pdf-zoom iconsconfig-list">
    <!-- <vs-button radius type="filled" icon-pack="feather" icon="icon-download" @click.stop="download" v-if="displayDownloadBtn"></vs-button>
    <vs-button radius type="filled" icon-pack="feather" icon="icon-printer" @click.stop="print" v-if="displayPrintBtn"></vs-button>
    <vs-button radius type="filled" icon-pack="feather" icon="icon-zoom-out" @click.stop="zoomOut" v-if="displayZoomOutBtn"></vs-button>
    <vs-button radius type="filled" icon-pack="feather" icon="icon-zoom-in" @click.stop="zoomIn" v-if="displayZoomInBtn"></vs-button>
    <vs-button radius type="filled" icon-pack="feather" icon="icon-maximize" @click.stop="maximize(true)" v-if="!isMaximized"></vs-button>
    <vs-button radius type="filled" icon-pack="feather" icon="icon-minimize" @click.stop="maximize(false)" v-else></vs-button> -->
    <vx-tooltip text="Download" position="top" delay=".1s">
      <feather-icon icon="DownloadIcon"  class="cursor-pointer ml-4" @click.stop="download" v-if="displayDownloadBtn"></feather-icon>
    </vx-tooltip>
    <vx-tooltip text="Imprimir" position="top" delay=".1s">
      <feather-icon icon="PrinterIcon"  class="cursor-pointer ml-4" @click.stop="print" v-if="displayPrintBtn"></feather-icon>
    </vx-tooltip>
    <vx-tooltip text="Diminuir" position="top" delay=".1s">
      <feather-icon icon="ZoomOutIcon"  class="cursor-pointer ml-4" @click.stop="zoomOut" v-if="displayZoomOutBtn"></feather-icon>
    </vx-tooltip>
    <vx-tooltip text="Aumentar" position="top" delay=".1s">
      <feather-icon icon="ZoomInIcon" class="cursor-pointer ml-4" @click.stop="zoomIn" v-if="displayZoomInBtn"></feather-icon>
    </vx-tooltip>
    <vx-tooltip text="Maximizar" position="top" delay=".1s" v-if="!isMaximized">
      <feather-icon icon="MaximizeIcon" class="cursor-pointer ml-4" @click.stop="maximize(true)" v-if="!isMaximized"></feather-icon>
    </vx-tooltip>
    <vx-tooltip text="Minimizar" position="top" delay=".1s" v-else>
      <feather-icon icon="MinimizeIcon" class="cursor-pointer ml-4" @click.stop="maximize(false)" ></feather-icon>
    </vx-tooltip>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    scale: {
      type: Number,
      default: 1.0
    },
    increment: {
      type: Number,
      default: 0.25
    },
    isMaximized: {
      type: Boolean,
      default: false
    },
    displayDownloadBtn: {
      type: Boolean,
      default: false
    },
    displayPrintBtn: {
      type: Boolean,
      default: true
    },
    displayZoomOutBtn: {
      type: Boolean,
      default: true
    },
    displayZoomInBtn: {
      type: Boolean,
      default: true
    },
    isDesktop: {
      type: Boolean
    }
  },
  methods: {
    zoomIn() {
      this.$emit("change", this.scale + this.increment);
    },
    zoomOut() {
      if (this.scale <= this.increment) return;
      this.$emit("change", this.scale - this.increment);
    },
    maximize(value) {
      this.$emit("maximize", value);
    },
    print() {
      this.$emit("printPdf", true);
    },
    download() {
      this.$emit("download", true);
    }
  }
};
</script>

<style>
.pdf-zoom {
  /* cursor: pointer; */
  text-align: right;
  display: contents;
}
.pdf-zoom.header-item {
  /* position: absolute; */
    right: 10px;
    top: 70px;
}
.pdf-document {
    /* margin-top: 0px;
    padding-top: 0px !important; */
}
.pdf-zoom.header-item {
  display: flex;
}
button.vs-component.vs-button.vs-button-primary.vs-button-filled.includeIcon.includeIconOnly.vs-radius {
    background: #EFEFEF !important;
    color: #000 !important;
    font-size: 2rem !important;
    border-radius: 50px !important;
    margin-right: 10px;
    box-shadow: none !important;
}
.theme-dark button.vs-component.vs-button.vs-button-primary.vs-button-filled.includeIcon.includeIconOnly.vs-radius {
  background: #353E45 !important;
  color: #FFF !important;
}
.theme-dark button.vs-component.vs-button.vs-button-primary.vs-button-filled.includeIcon.includeIconOnly.vs-radius:hover {
  background: #2D343B !important;
}

button.vs-component.vs-button.vs-button-primary.vs-button-filled.includeIcon.includeIconOnly.vs-radius:hover {
    background: #eaefdf !important;
}
.icon-zoom-out, .icon-zoom-in, .icon-minimize, .icon-maxmize {
    font-size: 1.4rem;
}
</style>
